import { render, staticRenderFns } from "./tieba-float-panel.vue?vue&type=template&id=be134f48&"
import script from "./tieba-float-panel.vue?vue&type=script&lang=js&"
export * from "./tieba-float-panel.vue?vue&type=script&lang=js&"
import style0 from "./tieba-float-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports